import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

@Injectable({
    providedIn: "root",
})
export abstract class PingService {
    public abstract ping(): Observable<boolean>;
}
